var Curriculog = Curriculog || {};


Curriculog.ImpactReportWarning = (function ($, _, Backbone, ImpactReportWarning) {
    ImpactReportWarning = Curriculog.PromiseDialog.extend({
        title: 'Warning',
        dialogClass: 'curriculog-dialog warning',
        message: 'Prefix, Code and External System are all required for an Impact Report. ' +
                 'Please complete the required information and run the report again.',
        buttons: {
            'OK': '_resolve'
        }

    });
    return ImpactReportWarning;
})($, _, Backbone, Curriculog.ImpactReportWarning || {});


Curriculog.ReportConfirm = (function ($, _, Backbone, ReportConfirm) {
    ReportConfirm = Curriculog.PromiseDialog.extend({
        title: 'Confirm Report Submission',
        message:
            'Your report is almost ready to be processed. Depending on the ' +
            'parameters you selected, this report could take up to an hour ' +
            'to generate. When it is complete, you will receive an email with ' +
            'a link to download the report. Are you ready to submit the report now?',
        buttons: {
            'Confirm Submission': '_resolve',
            'Cancel': '_reject'
        }

    });
    return ReportConfirm;
})($, _, Backbone, Curriculog.ReportConfirm || {});



